export default __webpack_public_path__ + "static/media/blue-deck.4d78bf31.svg";